import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    daysBetween: { type: Number }
  }

  static targets = [
    "shrinkPercentage",
    "dailyGain",
    "outputHidden",
    "outputVisible"
  ]

  connect() {
    this.calculate()
    this.bindAvgWt()
  }

  disconnect() {
    const avgWtInput = document.getElementById("assessment_avg_wt")
    if (avgWtInput && this.boundCalculate) {
      avgWtInput.removeEventListener("input", this.boundCalculate)
      avgWtInput.removeEventListener("change", this.boundCalculate)
    }
  }

  bindAvgWt() {
    const avgWtInput = document.getElementById("assessment_avg_wt")
    if (!avgWtInput) return
    this.boundCalculate = this.calculate.bind(this)
    avgWtInput.addEventListener("input", this.boundCalculate)
    avgWtInput.addEventListener("change", this.boundCalculate)
  }

  calculate() {
    const avgWtInput = document.getElementById("assessment_avg_wt")
    if (!avgWtInput) return

    const avgWt = parseFloat(avgWtInput.value)
    const shrinkPct = parseFloat(this.shrinkPercentageTarget.value)
    const dailyGain = parseFloat(this.dailyGainTarget.value)
    const daysBetween = this.hasDaysBetweenValue ? this.daysBetweenValue : 0

    const avgWtNum = Number.isNaN(avgWt) ? 0 : avgWt
    const shrinkPctNum = Number.isNaN(shrinkPct) ? 0 : shrinkPct
    const dailyGainNum = Number.isNaN(dailyGain) ? 0 : dailyGain

    const result = (avgWtNum + (daysBetween * dailyGainNum)) * (1 - shrinkPctNum / 100)
    const value = Number.isNaN(result) ? "" : Number(result.toFixed(1))

    this.outputHiddenTarget.value = value
    this.outputVisibleTarget.value = value
  }
}
